import { FC, Fragment, useCallback } from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDialog } from "@/utils/hooks/useDialog.hook";
import { DashboardCreateFolderOrItemDialog } from "@/components/app-navigation/components/page-components/dashboard/components/DashboardCreateFolderOrItemDialog";
import { NavigationItemsVisibilityType } from "@/store/navigation/utils/types";
import { useAppAbility } from "@/services/permissions";

interface DashboardFolderAddDashboardProps {
  id: string;
  onOpen?(): void;
  onClose?(): void;
  iconButon?: boolean;
  visibility: NavigationItemsVisibilityType;
}

export const DashboardFolderAddDashboard: FC<
  DashboardFolderAddDashboardProps
> = ({ id, visibility, iconButon, onClose, onOpen }) => {
  const { cannot } = useAppAbility();
  const cannotCreateDashboard = cannot("create", "dashboard");
  const {
    open: openAdd,
    openDialog: openAddDialog,
    closeDialog: closeAddDialog,
  } = useDialog();

  const openHandler = useCallback(() => {
    onOpen?.();
    openAddDialog();
  }, [onOpen, openAddDialog]);

  const closeHandler = useCallback(() => {
    onClose?.();
    closeAddDialog();
  }, [onClose, closeAddDialog]);

  return (
    <Fragment>
      <Tooltip title={iconButon ? "Add Dashboard" : ""} arrow placement="top">
        <span>
          {iconButon ? (
            <IconButton
              size="small"
              sx={iconButtonStyles}
              disabled={cannotCreateDashboard}
              onClick={openHandler}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          ) : (
            <Button
              size="small"
              variant="text"
              onClick={openHandler}
              disabled={cannotCreateDashboard}
              startIcon={<AddIcon fontSize="small" />}
            >
              Add Dashboard
            </Button>
          )}
        </span>
      </Tooltip>

      {openAdd && (
        <DashboardCreateFolderOrItemDialog
          redirectAfterCreate
          onClose={closeHandler}
          type="item"
          folderId={id}
          visibility={visibility}
        />
      )}
    </Fragment>
  );
};

const iconButtonStyles = { p: 0.3, "&:hover": { bgcolor: "grey.200" } };
